import Controller from './controllers/application'
import {dispatch} from 'structure-dispatcher'

const controller = new Controller()

const express = require('express')
const routes = express.Router()

import schemaCreate from './schemas/create'
import schemaUpdate from './schemas/update'

routes.get('/of/users/:id',                       dispatch(controller, 'ofUser', {collectionName: true}))
routes.get('/by/hosts/:hostname',                 dispatch(controller, 'byHostname'))
routes.get(`/:id/organization`,                   dispatch(controller, 'getOrganization'))
routes.get(`/:id`,                                dispatch(controller, 'getById'))
routes.get(`/`,                                   dispatch(controller, 'getAll'))

routes.patch(`/:id`, schemaUpdate,                dispatch(controller, 'updateById'))

routes.post(`/`, schemaCreate,                    dispatch(controller, 'create'))

routes.delete(`/:id`,                             dispatch(controller, 'deleteById'))

export default function routesHandler(options = {}) {

  return {
    routeName: 'applications',
    routes
  }

}
